import styled from 'styled-components';

// export const FullWidthContainer = styled.div`
//   width: 100%;
//   margin: 0 auto;
//   padding-right: 15px;
//   padding-left: 15px;
//   position: relative;
// `;

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding-right: 15px;
  padding-left: 15px;
  position: relative;

  max-width: ${({isFullWidth}) => isFullWidth ? 'none' : '1200px'};
  /* @media (min-width: 576px) {
    width: 540px;
  }

  @media (min-width: 768px) {
    width: 620px;
  }

  @media (min-width: 992px) {
    width: 890px;
  }

  @media (min-width: 1200px) { */
    /* width: 1070x; */
    /* width: 1200px;
  } */

  /* @media (min-width: 1400px) {
    width: 1200px; */
    /* width: 1290px; */
  /* } */

  /* @media (min-width: 1600px) {
    width: 1520px;
  } */
`;

export const ContainerWrapper = styled.div`
  padding: 30px 0;

  @media (min-width: 992px) {
    padding: 50px 0;
  }
`;